import React from 'react';
import CertificateLogTable from './CertificateLogTable/CertificateLogTable';

const CertificateLog = () => {
  return <CertificateLogTable />;
};

export default CertificateLog;
